import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { app } from "../../Frame/App";

export class ColumnDocuments extends ColumnBase {

    public getContent(row: any): HTMLElement {
        if (this.hasDocuments(row)) {
            return (
                <div className="dropdown">
                    <i className="fal fa-paperclip" data-toggle="dropdown"></i>
                    <div className="dropdown-menu">
                        {row[this.field].map((item: any) => {
                            return <a className="dropdown-item" href={app.resolveUrl("~/api/documents/get/" + item.id)}>{item.name}</a>
                        })}
                    </div>
                </div>
            );
        }
        return null;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-documents");
        if (this.hasDocuments(rowModel)) {
        }
        return cell;
    }

    private hasDocuments(model: any): boolean {
        if (model[this.field] && model[this.field].length && model[this.field].length > 0) {
            return true;
        }
        return false;
    }
}